import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { RouterModule } from '@angular/router';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeHeaderComponent } from './components/home-header/home-header.component';
import { HomeHeroComponent } from './components/home-hero/home-hero.component';
import { HomeNewsUpdatesComponent } from './components/home-news-updates/home-news-updates.component';
import { HomeCustomTopHeaderComponent } from './components/home-custom-top-header/home-custom-top-header.component';
import { AvatarModule } from 'ngx-avatars';
import { TranslocoModule } from '@jsverse/transloco';
import { MaterialModule } from 'src/app/shared/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedPipeModule } from 'src/app/shared/shared-pipe.module';

@NgModule({
    declarations: [HomeComponent, HomeHeaderComponent, HomeHeroComponent, HomeNewsUpdatesComponent, HomeCustomTopHeaderComponent],
    imports: [
        CommonModule,
        NgbModule,
        RouterModule,
        RouterModule.forChild([{ path: 'home', component: HomeComponent }]),
        AvatarModule,
        TranslocoModule,
        MaterialModule,
        NgbCarouselModule,
        SharedModule,
        SharedPipeModule,
    ],
    exports: [HomeComponent, HomeHeaderComponent, HomeCustomTopHeaderComponent],
})
export class HomeModule {}
